import { render, staticRenderFns } from "./search-aside-widget.vue?vue&type=template&id=c3219f52"
import script from "./search-aside-widget.vue?vue&type=script&lang=js"
export * from "./search-aside-widget.vue?vue&type=script&lang=js"
import style0 from "./search-aside-widget.vue?vue&type=style&index=0&id=c3219f52&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports